module.exports = __webpack_public_path__ + "static/tvcm-4x-88eb42fac6ed658f48d633fed9761607.png";